// extracted by mini-css-extract-plugin
module.exports = {"ShareListWrapper":"ShareList_ShareListWrapper__Ljn7c","ShareListMoreOptionsWrapper":"ShareList_ShareListMoreOptionsWrapper__AqO1k"};